import {
  getNodeOutputPosition,
  getNodeInputPosition,
  calculateConnectionPath,
} from '../../utils/sandbox/sandboxUtils';

const Connection = ({ connection, nodes, onDelete, temporary = false }) => {
  const sourceNode = nodes.find((n) => n.id === connection.sourceNodeId);
  const targetNode = nodes.find((n) => n.id === connection.targetNodeId);

  if (!sourceNode || !targetNode) {
    return null;
  }

  const sourcePos = getNodeOutputPosition(sourceNode, connection.sourceOutputId);
  const targetPos = getNodeInputPosition(targetNode, 0);

  const handleConnectionClick = (e) => {
    e.stopPropagation();
    if (onDelete && !temporary) {
      onDelete();
    }
  };

  const pathData = calculateConnectionPath(sourcePos, targetPos);

  const connectionStyle = {
    stroke: temporary ? '#ff9800' : '#2196F3',
    strokeWidth: temporary ? 3 : 2,
    fill: 'none',
    cursor: temporary ? 'default' : 'pointer',
    strokeDasharray: temporary ? '5,5' : 'none',
    opacity: temporary ? 0.7 : 1,
  };

  return (
    <g className={`connection ${temporary ? 'temporary' : ''}`}>
      <path
        d={pathData}
        stroke="transparent"
        strokeWidth="12"
        fill="none"
        onClick={handleConnectionClick}
        style={{ cursor: 'pointer' }}
      />

      <path
        id={connection.id}
        d={pathData}
        style={connectionStyle}
        markerEnd="none"
        onClick={handleConnectionClick}
      />

      {!temporary && (
        <text
          x={(sourcePos.x + targetPos.x) / 2}
          y={(sourcePos.y + targetPos.y) / 2 - 5}
          textAnchor="middle"
          className="connection-label"
          fill="#666"
          fontSize="10"
        >
          {connection.sourceOutputId}
        </text>
      )}

      {!temporary && (
        <circle r="3" fill="#2196F3" className="flow-indicator">
          <animateMotion dur="2s" repeatCount="indefinite">
            <mpath href={`#${connection.id}`} />
          </animateMotion>
        </circle>
      )}
    </g>
  );
};

export default Connection;
